import indexedDBHelper from '@/helper/indexedDBHelper';
import { useRootStore } from '@/store/root';
import { useContextLinksStore } from '@/store/contextLinks';
import { useCalendarStore } from '@/store/calendar';
import { useDashboardStore } from '@/store/dashboard';

const routes = [
  {
    path: 'dashboard',
    meta: {
      public: false,
    },
    beforeEnter: async (to, from, next) => {
      const { dashboard, weeklyPlanner } =
        await indexedDBHelper.getData('meta');

      const type = 'dashboard';
      useRootStore().parentObject = { type };

      await useDashboardStore().initDashboard(dashboard);
      useContextLinksStore().setContextLinks({
        type,
        contextLinks: dashboard.contextLinks,
      });
      useCalendarStore().initCalendar(weeklyPlanner);
      next();
    },
    component: () => import('@/layouts/Main.vue'),
    children: [
      {
        path: '',
        redirect: '/',
      },
      {
        path: ':id',
        name: 'dashboard.home',
        beforeEnter: async (to, from, next) => {
          const { id } = to.params;
          const dashboardStore = useDashboardStore();

          if (id === 'home') {
            await dashboardStore.fetchDashboards();
            const guid = dashboardStore.getDefaultDashboard;

            await dashboardStore.setSelectedDashboard({ guid });
          } else {
            await dashboardStore.setSelectedDashboard({
              guid: id,
            });
          }
          next();
        },
        component: () =>
          import('@/views/dashboards/DashboardHome/DashboardHome.vue'),
      },
      {
        path: 'calendar',
        name: 'dashboard.calendar',
        beforeEnter: async (to, from, next) => {
          next();
        },
        component: () => import('@/views/weeklyPlanner/WeeklyPlanner.vue'),
      },
      {
        path: 'history',
        name: 'dashboard.history',
        component: () => import('@/views/history/NavigationHistory.vue'),
      },
      {
        path: 'messages',
        name: 'dashboard.messages',
        component: () => import('@/views/history/Messages.vue'),
      },
    ],
  },
];

export default routes;
